export default __webpack_public_path__ + "static/media/WAG Symbols.a233d70a.otf";